import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Tooltip } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function DirectDataEstimatedIncomeTable(props) {
  const classes = useStyles();
  useTheme();

  const { direct_data_estimated_income_data } = props

  const formatIncome = (value) => {
    if (value == null) return " - "
    return "R$ " + value.toLocaleString("pt-BR", { minimumFractionDigits: 2 })
  }

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }
    return classes.odd;
  };

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                CBO
                <Tooltip title={<p className="tooltipText">Classificação Brasileira de Ocupações - código que identifica a ocupação profissional</p>}>
                  <HelpIcon style={{fontSize: "14px", margin: "auto 0px auto 4px"}}/>
                </Tooltip>
              </div>
            </TableCell>
            <TableCell className={classes.tableHeader}>Código CBO</TableCell>
            <TableCell className={classes.tableHeader}>Classe Social</TableCell>
            <TableCell className={classes.tableHeader}>Faixa Salarial</TableCell>
            <TableCell className={classes.tableHeader}>Renda Estimada</TableCell>
            <TableCell className={classes.tableHeader}>Renda Média CBO</TableCell>
            <TableCell className={classes.tableHeader}>Renda Mínima CBO</TableCell>
            <TableCell className={classes.tableHeader}>Renda Máxima CBO</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {direct_data_estimated_income_data.map((each_income, index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            >
              <TableCell className={classes.tableText}>
                {each_income.cbo}
              </TableCell>
              <TableCell className={classes.tableText}>
                {each_income.cbo_code}
              </TableCell>
              <TableCell className={classes.tableText}>
                {each_income.social_class}
              </TableCell>
              <TableCell className={classes.tableText}>
                {each_income.salary_range}
              </TableCell>
              <TableCell className={classes.tableText}>
                {formatIncome(each_income.estimated_income)}
              </TableCell>
              <TableCell className={classes.tableText}>
                {formatIncome(each_income.cbo_average_income)}
              </TableCell>
              <TableCell className={classes.tableText}>
                {formatIncome(each_income.cbo_minimum_income)}
              </TableCell>
              <TableCell className={classes.tableText}>
                {formatIncome(each_income.cbo_maximum_income)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default DirectDataEstimatedIncomeTable;
